export default __webpack_public_path__ + "426fc6e.png";